import * as React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {
    selectComicsForChapter,
    selectProgressForChapter,
} from '../../../store/reducers';
import ProgressBar from '../../ProgressBar';
import {Link} from 'react-router-dom';
import {webMediaQuery} from '../../../styles';

const RecentReadItem = props => {
    let {t} = useTranslation();
    const comic = useSelector(state =>
        selectComicsForChapter(state, props.chapter.id),
    );
    const progress = useSelector(state =>
        selectProgressForChapter(state, props.chapter.id),
    );

    const _onPress = () => {
        props.onPress(props.chapter);
    };

    return (
        <BaseDiv style={{marginRight: props.marginRight}}>
            <Container
                width={props.width}
                onPress={_onPress}
                marginRight={0}
                to={`/comics/${comic.friendlyName}/${props.chapter.number}`}
            >
                <Image
                    src={
                        props.useChapterCover
                            ? `${comic.baseUrl}/${props.chapter.number}/${props.chapter.cover}`
                            : `${comic.baseUrl}${comic.cover}`
                    }
                    landscape={props.useChapterCover}
                />
                <TextHolder>
                    <TextTitle numberOfLines={1}>
                        {t('comics.chapter')} {props.chapter.number}
                    </TextTitle>
                    <TextTitle numberOfLines={1}>{comic.title}</TextTitle>
                    <TextSerie numberOfLines={2}>{comic.show}</TextSerie>
                </TextHolder>
                <ButtonPlay>{t('comics.read')}</ButtonPlay>
            </Container>
            <StyledProgressBar
                percent={progress}
                width={props.width}
                trackColor="#494249"
            />
        </BaseDiv>
    );
};

const BaseDiv = styled.div`
    transition: transform 0.35s cubic-bezier(0.68, -0.51, 0.22, 1.68);
    &:hover {
        ${webMediaQuery} {
            transform: scale(1.03);
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        }
    }
`;

const Container = styled(Link)`
    display: flex;
    background-color: #211921;
    width: ${props => props.width}px;
    flex-direction: row;
    align-items: center;
    padding: 10px 12px;
    margin-right: ${props => props.marginRight}px;
    color: transparent;
`;

const TextHolder = styled.div`
    flex: 1;
    padding: 0px 14px;
`;

const TextTitle = styled.div`
    font-family: AvenirNextRoundedStd;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    color: white;
    text-transform: uppercase;
`;

const TextSerie = styled.div`
    font-family: AvenirNextRoundedStd;

    font-size: 14px;
    line-height: 15px;
    color: white;
    margin-top: 8px;
`;

const Image = styled.img`
    width: ${props => (props.landscape ? 100 : 64)}px;
    height: ${props => (props.landscape ? 60 : 90)}px;
    overflow: hidden;
`;

const ButtonPlay = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    color: white;
    padding: 8px 15px;
    background-color: rgba(255, 255, 255, 0.18);
    border-radius: 16px;
    overflow: hidden;
    text-transform: uppercase;
`;

const StyledProgressBar = styled(ProgressBar)`
    border-radius: 0;
    width: 100%;
`;

export default RecentReadItem;
